import React from "react";

import styles from "../PreviewV3.module.css";

export default function MethodItemType({ sectionData, displayName, sectionNumber, targetId }) {
  const safeSectionData = sectionData || {};
  const methodItems = Array.isArray(safeSectionData.method_items) ? safeSectionData.method_items : [];

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <ul className={styles.PreviewMethodItemTypeGrid}>
          {methodItems.map((item, index) => (
            <MethodItem key={index} item={item} />
          ))}
        </ul>
      </div>
    </div>
  )
}

const MethodItem = ({ item }) => {
  const safeItem = item || {};

  return (
    <li className={styles.PreviewMethodItemTypeGridItem}>
      {safeItem.selected && safeItem.selected === 1 ? (
        <svg width="14" height="14" viewBox="0 0 16 16" className={styles.PreviewMethodItemCheckbox}>
          <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3" fill="#10B981" stroke="#10B981"></rect>
          <path d="M4 8.3 L7 11 L12 4.8" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 16 16" className={styles.PreviewMethodItemCheckbox}>
          <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3" fill="#fff" stroke="#CBD5E1" strokeWidth="1.2"></rect>
        </svg>
      )}
      <span>{safeItem.method_item}</span>
    </li>
  )
}